<template>
<div>
  <div class="tip pb-wide">
    <p>* 결재문서 백업은 완료된 문서만 가능합니다.</p>
    <p>* 백업되는 항목은 문서 내용과 결재선 정보이며, pdf 파일로 백업됩니다.</p>
    <p>* 결재문서 백업이 소요되는 시간은 백업문서의 크기에 따라 최대 며칠까지 걸릴 수 있습니다.</p>
    <p class="warning">* 완료된 백업 파일은 회사 업무용량에 포함됩니다.</p>
  </div>
</div>
</template>

<script>
export default {
  name: 'Backup'
}
</script>

<style scoped>
.th-fix-management,
.td-fix-management{
  width:214px;
}

.pb-wide{ margin-bottom:1.5rem !important;}

.tip { padding:24px; background-color: #fff; }
.tip p {color:#757575}
.tip p.warning {color:red; font-weight: 500}
</style>
